export default "__VITE_ASSET__C532qtn5__"